import { InvoiceLine } from './type';

// Helper function to round numbers to avoid floating point issues
export const roundResult = (value: number) =>
    (Math.round((value + Number.EPSILON) * 100) / 100)
  
  // Compute the line total (applying discount first, then VAT)
  export const computeLineTotal = (lineData: InvoiceLine, isVatInclusiveInput: boolean = false): number => {
    const netUnitPrice = roundResult(
      lineData.unitPrice * (1 - lineData.discount / 100),
    )
    const unitVat = roundResult(netUnitPrice * (lineData.vat / 100))
  // ✅ Only update unitPriceInclVat if it's derived from unitPrice
  if (!isVatInclusiveInput) {
    lineData.unitPriceInclVat = roundResult(lineData.unitPrice + unitVat)
  }

    return roundResult(lineData.amount * (netUnitPrice + unitVat))
  }

export const calculateSubtotal = (lines: InvoiceLine[]) => {
  return lines
    .reduce((total, line) => total + line.unitPrice * (1 - line.discount / 100) * line.amount, 0)
    .toFixed(2);
};

export const getLineVAT = (line: InvoiceLine) => {
  const vatRate = line.vat / 100;
  const vatPerItem = roundResult(
    line.unitPrice * (1 - line.discount / 100) * vatRate,
  )
  return roundResult(vatPerItem * line.amount)
};

export const calculateVAT = (lines: InvoiceLine[]) => {
  return lines.reduce((totalVAT, line) => totalVAT + getLineVAT(line), 0).toFixed(2);
};

export const calculateTotal = (lines: InvoiceLine[]) => {
  return lines.reduce((total, line) => total + line.lineTotal, 0).toFixed(2);
};

export const calculateAmount = (lines: InvoiceLine[]) => {
  const total = lines.reduce((sum, line) => sum + Number(line.amount), 0);
  return total === 0 ? '' : total;
};
